import { common as unauthenticatedSharedCommon } from "@unauthenticated/shared/locales/en/US";
const common = {
  ...unauthenticatedSharedCommon,
  modality: "Modality",
  LandingPage: {
    title: "Are you new to Fullscript?",
    subTitle: "Choose an option below to begin your Fullscript migration.",
    option1: "I'm new to Fullscript",
    option2: "I already have a Fullscript account",
    buttonLabel: "Continue",
  },
  WellevateAuthenticationPage: {
    fsSignIn: "I already have a Fullscript account",
    title: "Sign in with Wellevate to continue",
    wellevateByFullscript: "Wellevate by Fullscript",
    wellevateEmail: "Wellevate email",
    wellevatePassword: "Wellevate password",
    signIn: "Sign in",
    forgotPassword: "Forgot your Wellevate password?",
    passwordRequirements: "<0/><1/>Must be 8 characters long",
    incorrectEmailorPassword: "Incorrect email or password. Please try again.",
    passwordIsRequired: "Password is required",
  },
  AccountDetails: {
    message: {
      title: "Wellevate account sign in success",
      content: "Welcome {{practitionerName}}, let’s set up your Fullscript account",
    },
    title: "Create a Fullscript practitioner account",
    subTitle: "First, double check that the information below is correct.",
    modalityTooltip:
      "We've imported your modality from Wellevate, and have matched it as closely as possible to the Fullscript equivalent. You can update this later, if necessary.",
    buttonLabel: "Continue",
    modalityError: {
      title: "Unable to find a matching modality",
      subTitle:
        "We've imported your modality from Wellevate, but could not match it to one in our database. Please contact <1>help & support</1> for next steps.",
      buttonLabel: "Help & support",
    },
  },
  WellevateAccountErrorPage: {
    title: "It looks like {{ wellevateEmail }} is already connected to a Fullscript account",
    subTitle:
      "This email address has already been used to connect a Wellevate account to a Fullscript account. You can go back and choose another email, or use your Fullscript credentials to sign in. Need help? <1>Contact us</1>.",
    buttons: {
      goBack: "Go back",
      signIn: "Sign in",
    },
  },
  RegistrationPage: {
    title: "Complete your account",
    subTitle: "Choose your preferred email and password for accessing Fullscript",
    buttonLabel: "Create account",
  },
} as const;

export { common };
